import PlaceBaseSource from './PlaceBaseSource';

export default class PlaceFencesSource extends PlaceBaseSource {
  /** @var {String} id */
  static id = 'place-fences';
}
